import React from 'react';
import { Box, Typography, Paper, Button, Container } from '@mui/material';
import { CheckCircle, ArrowRight } from 'lucide-react';
import RegistrationHeader from './CadEscriComponents/RegistrationHeader';

const Congratulations: React.FC = () => {
    return (
        <Container maxWidth="lg">
            <RegistrationHeader isText={false} />
            <Paper
                elevation={5}
                sx={{
                    p: 4,
                    textAlign: 'center',
                    borderRadius: 3,
                    maxWidth: 600,
                    mx: 'auto',
                    bgcolor: 'background.paper',
                    position: 'relative',
                    overflow: 'hidden'
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: 6,
                        bgcolor: 'primary.main',
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12
                    }}
                />

                <CheckCircle
                    size={64}
                    color="#2e7d32"
                    strokeWidth={1.5}
                />

                <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                        mt: 3,
                        mb: 2,
                        fontFamily: '"Playfair Display", serif',
                        fontWeight: 600
                    }}
                >
                    Bem vindo ao SysproJud
                </Typography>

                <Typography
                    variant="h6"
                    color="text.secondary"
                    sx={{ mb: 3, fontWeight: 400 }}
                >
                    Parabéns! Seu cadastro foi realizado com sucesso.
                </Typography>

                <Box
                    sx={{
                        bgcolor: 'background.default',
                        p: 3,
                        borderRadius: 2,
                        mb: 4
                    }}
                >
                    <Typography color="text.secondary">
                        Enviamos um e-mail de confirmação pra voce
                    </Typography>
                </Box>

                <Button
                    variant="contained"
                    size="large"
                    endIcon={<ArrowRight size={20} />}
                    onClick={() => window.location.href = '/'}
                    sx={{
                        px: 4,
                        py: 1.5,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontSize: '1.1rem',
                        fontWeight: 500,
                        '&:hover': {
                            transform: 'translateY(-2px)',
                            transition: 'transform 0.2s'
                        }
                    }}
                >
                    Vamos para o painel
                </Button>
            </Paper>
        </Container>
    );
};

export default Congratulations;